import { typeOf } from '@ember/utils';
import currency from '../currency-core.js';
import { listCurrency } from './_shared.js';

/**
 * @module beebee-base/lib/utility/currency
 * @description Currency conversion, formatting and normalization utilities.
 *
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — currency string↔number conversion, Italian-locale
 *              formatting, model view/edit component lookup, socket pageview
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      ../currency-core (currency formatting), ./_shared (listCurrency)
 *   siblings:  sibling lib/utility/*.js modules (all re-exported via ../utility.js barrel)
 *   tests:     utility-test.js, utility-wave4-test.js, utility-wave5-test.js
 */


/**
 * Converte una stringa valuta in numero
 * @param {string|number} item - Valore da convertire
 * @returns {number|null} Valore numerico
 */
function currency2Number(item) {
  if (item === null || item === undefined || item === '') {
    return null;
  }
  if (typeOf(item) === 'number') {
    return item;
  }
  if (typeOf(item) === 'string') {
    // Detect format: if contains comma → Italian format (1.234,56)
    // If no comma and has dot → JS/English format (1234.56)
    if (item.includes(',')) {
      return currency(item, {
        separator: '.',
        decimal: ','
      }).value;
    }
    return parseFloat(item) || 0;
  }
  return item;
}

/**
 * Converte un numero in stringa formattata come valuta italiana
 * @param {string|number} item - Valore da formattare
 * @returns {string|null} Stringa formattata
 */
function number2Currency(item) {
  if (item === undefined) {
    return null;
  }
  const itemType = typeOf(item);
  if (itemType === 'string' || itemType === 'number') {
    const options = itemType === 'string' && item.includes(',') ? {
      symbol: '',
      decimal: ','
    } : {
      symbol: ''
    };
    const currencyValue = currency(item, options).value;
    return currency(currencyValue, {
      separator: '.',
      decimal: ',',
      symbol: ''
    }).format();
  }
  return item;
}
function setModelParameter(_this, item) {
  if (!item) return {};
  const modelName = item.constructor.modelName;
  const roleApp = _this.session?.me?.role?.application;
  return {
    componentDetailName: roleApp?.[`${modelName}_view`],
    componentEditName: roleApp?.[`${modelName}_edit`],
    route: modelName === 'invoice' ? `${item.document_type}s` : `${modelName}s`
  };
}
function sendSocketPageView(socketService, item, isPopup, popupAction, indexAction) {
  if (!socketService) {
    return;
  }
  var socketData = {
    targetName: null,
    model: indexAction ? item : item.constructor.modelName,
    model_id: indexAction ? null : item.id,
    is_popup: isPopup,
    popup_action: popupAction,
    index_action: indexAction,
    action: null
  };
  socketService.emit('pageview', socketData);
}
function formatEuro(number) {
  if (number) {
    return number2Currency(number);

    /*var numberStr = parseFloat(number).toFixed(2).toString();
    var numFormatDec = numberStr.slice(-2);
    numberStr = numberStr.substring(0, numberStr.length - 3);
    var numFormat = [],
      nToSubtract = 3;
     if (numberStr[0] === '-') {
      nToSubtract = 4;
    }
     while (numberStr.length > nToSubtract) {
      numFormat.unshift(numberStr.slice(-3));
      numberStr = numberStr.substring(0, numberStr.length - 3);
    }
    numFormat.unshift(numberStr);
    return numFormat.join('.') + ',' + numFormatDec;*/
  }
  return '0,00';
}

/**
 * Normalizza un codice valuta, ritorna EUR se non supportato
 * @param {string} currency - Codice valuta
 * @returns {string} Codice valuta normalizzato
 */
function normalizeCurrency(currencyCode) {
  return listCurrency.includes(currencyCode) ? currencyCode : 'EUR';
}

export { currency2Number, formatEuro, normalizeCurrency, number2Currency, sendSocketPageView, setModelParameter };
//# sourceMappingURL=currency.js.map
